import { Inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private initialized = false;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  init(): void {
    const id = (environment as any).ga4MeasurementId;
    if (!id || this.initialized) {
      return;
    }

    const w = this.doc.defaultView as any;
    if (!w) {
      return;
    }

    // 1. Cargar script gtag.js dinámicamente
    const script = this.doc.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    this.doc.head.appendChild(script);

    // 2. Configurar dataLayer y gtag
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', id, { send_page_view: false });

    // 3. Trackear navegación automáticamente
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      w.gtag('event', 'page_view', { page_path: e.urlAfterRedirects });
    });

    this.initialized = true;
  }
}
